import styled from '@emotion/styled';
import { Variables } from '@enter/core';

export const Body = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
    box-sizing: border-box;
    padding: 8px 22px 22px;
`;

export const Field = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;
`;

export const Label = styled.label`
    font-family: ${Variables.Fonts.calibre};
    font-size: 13px;
    line-height: 1.4;
    color: ${Variables.ThemeLight.TextMild};
`;

export const Note = styled.p`
    margin: 0;
    font-family: ${Variables.Fonts.calibre};
    font-size: 13px;
    line-height: 1.4;
    color: ${Variables.ThemeLight.AttentionInverted3};
`;

export const Actions = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 8px;
`;
